export const MIN_CENTER_COUNT_THRESHOLD = 10

export const THIRD_PARTY_REVIEW_PLATFORMS = {
  GOOGLE: 'google'
}

export const THIRD_PARTY_REVIEW_PROVIDERS = {
  ELFSIGHT: 'elfsight',
  PLACE_ID: 'placeId'
}
